
import QdapHomeVideoSectionVideoCard from './qdap-home-video-section-video-card.vue';

export default {
  name: 'QdapHomeVideoSectionMobileComponent',

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
  },

  data() {
    return {
      length: 3
    }
  },

  computed: {
    showLoadMore() {
      return this.length < this.data?.Video.length;
    },

    videosComputed() {
      return this.data?.Video.slice(0, this.length)
    }
  },
  methods: {
    loadMore() {
      this.length = this.length + 3
    },
  },
}
